import { Alert } from './Alert.js'

/**
 * The reasons a save was refused, listed.
 *
 * Both screens that build a segment show these — the dialog that makes one and
 * the page that edits one — and they are the same refusals from the same
 * validation, so they read the same. Nothing at all when there are none, rather
 * than an empty box that reserves space for a failure that has not happened.
 *
 * Keyed by the text: the list is a set of distinct reasons, so there is no
 * position to key by and nothing that would reorder under somebody anyway.
 */
export function Problems({ problems }: { readonly problems: readonly string[] }) {
  if (problems.length === 0) return null

  return (
    <Alert>
      <ul className="space-y-1">
        {problems.map((problem) => (
          <li key={problem}>{problem}</li>
        ))}
      </ul>
    </Alert>
  )
}
